/* eslint-disable */
type CrTimestamp = number;
type CrJson = any;
type CrBigInt = number;
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCatalogBrowsingType
// ====================================================

export interface GetCatalogBrowsingType_pdp_browsing_type {
  type: PdpBrowsingType;
}

export interface GetCatalogBrowsingType {
  /**
   * PDP 브라우저 타입
   */
  pdp_browsing_type: GetCatalogBrowsingType_pdp_browsing_type | null;
}

export interface GetCatalogBrowsingTypeVariables {
  catalog_product_id: string;
  browsing_type?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum PdpBrowsingType {
  DETAIL_BROWSER = "DETAIL_BROWSER",
  INTERNAL_BROWSER = "INTERNAL_BROWSER",
  NATIVE_BROWSER = "NATIVE_BROWSER",
  NORMAL = "NORMAL",
  Z_BROWSER = "Z_BROWSER",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
